import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI } from '../utils/api';
import { useAuth } from '../hooks/useAuth';

export default function Login({ onSwitch }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authAPI.login(form);
      login(data.token, data.user);
      toast.success(`Bienvenue, ${data.user.nom}`);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erreur de connexion');
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div className="form-group">
        <label className="form-label">ADRESSE EMAIL</label>
        <input className="input" type="email" placeholder="you@tppartners.cm" autoComplete="email"
          value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
      </div>
      <div className="form-group">
        <label className="form-label">MOT DE PASSE</label>
        <input className="input" type="password" placeholder="••••••••" autoComplete="current-password"
          value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
      </div>
      <button className="btn btn-primary" type="submit" disabled={loading} style={{ marginTop: 8, padding: '13px 20px', fontSize: 13, letterSpacing: 2 }}>
        {loading ? <><span className="spinner" style={{ width: 14, height: 14 }}></span> CONNEXION...</> : '→ ACCÉDER AU SYSTÈME'}
      </button>
      <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-muted)', marginTop: 4 }}>
        Premier accès ?{' '}
        <span onClick={onSwitch} style={{ color: 'var(--cyan)', cursor: 'pointer', textDecoration: 'underline' }}>
          Créer un compte admin
        </span>
      </p>
    </form>
  );
}
